import "../../athlete.css";
import { ReactComponent as SearchInvidual } from "../../../../assets/elevva-pro-icons/search-individual-table.svg";

import { useState } from "react";
import ModalInfo from "../modal-info";
import PerfectScrollbar from "react-perfect-scrollbar";
import "react-perfect-scrollbar/dist/css/styles.css";

const Step2 = ({ edit, userDetail, setFormData }) => {
  const [modal, setModal] = useState(null);
  const medicalCategories = [
    {
      name: "Patológicos",
      value:
        userDetail?.customer_records?.pathological_history ||
        "No hay historial",
      label: "pathological_history",
    },
    {
      name: "Alérgicos",
      value:
        userDetail?.customer_records?.allergic_history || "No hay historial",
      label: "allergic_history",
    },
    {
      name: "Transfusionales",
      value:
        userDetail?.customer_records?.transfusion_history || "No hay historial",
      label: "transfusion_history",
    },
    {
      name: "Quirúrgicos",
      value:
        userDetail?.customer_records?.surgical_history || "No hay historial",
      label: "surgical_history",
    },
    {
      name: "Hospitalarios",
      value:
        userDetail?.customer_records?.hospitalization_history ||
        "No hay historial",
      label: "hospitalization_history",
    },
    {
      name: "Traumatológicos",
      value:
        userDetail?.customer_records?.traumatic_history || "No hay historial",
      label: "traumatic_history",
    },
    // {
    //   name: "Inmunológicos",
    //   value:
    //     userDetail?.customer_records?.immunological_history ||
    //     "No hay historial",
    //   label: "immunological_history",
    // },

    {
      name: "Tóxicos",
      value:
        userDetail?.customer_records?.toxic_exposure_history ||
        "No hay historial",
      label: "toxic_exposure_history",
    },
    {
      name: "Farmacológicos",
      value:
        userDetail?.customer_records?.medication_history || "No hay historial",
      label: "medication_history",
    },
    {
      name: "Heredofamiliares",
      value: userDetail?.customer_records?.family_history || "No hay historial",
      label: "family_history",
    },
  ];

  function handleModal(item) {
    setModal(
      <ModalInfo
        onCancel={() => setModal(null)}
        onConfirm={() => setModal(null)}
        loader={false}
      >
        <div className="d-flex flex-column ">
          <div
            className="d-flex justify-content-center pb-2"
            style={{ borderBottom: "0.5px solid #B6C1CE", textAlign: "center" }}
          >
            <span className="label-step">
              <strong>{item.name}</strong>
            </span>
          </div>
          <div className="p-2">
            <PerfectScrollbar style={{ height: "100%", maxHeight: "10vh" }}>
              <span className="input_info_athlete_input">{item.value}</span>
            </PerfectScrollbar>
          </div>
        </div>
      </ModalInfo>
    );
  }
  return (
    <div className="d-flex flex-column px-2" style={{ width: "80%" }}>
      {modal}
      <div className="d-flex justify-content-start">
        <span className="label-step">
          <strong>2.Antecedentes</strong>
        </span>
      </div>
      <div className="step2-grid-container pt-2">
        {medicalCategories.map((item, index) => {
          return (
            <div
              key={index}
              style={{ lineHeight: "1" }}
              className="step2-card input_info_athlete p-2"
            >
              <div className="d-flex justify-content-between align-items-center cursor-pointer ">
                <span className="pb-1">{item.name}</span>
                {!edit && (
                  <SearchInvidual
                    width={"calc(0.5rem + 0.5vw)"}
                    onClick={() => handleModal(item)}
                  />
                )}
              </div>
              <textarea
                className="input_info_athlete_input"
                placeholder={item.value}
                // defaultValue={item.value}
                readOnly={!edit}
                onChange={(e) => {
                  setFormData((prev) => ({
                    ...prev,
                    customer_records: {
                      ...prev.customer_records,
                      [item.label]: e.target.value,
                    },
                  }));
                }}
              />
            </div>
          );
        })}
      </div>
    </div>
  );
};
export default Step2;
